import { FC } from "preact/compat";
import { Outlet } from "react-router-dom";
import Header from "./Header";

const Me: FC = () => (
    <div className="w-screen h-screen max-w-screen max-h-screen overflow-hidden flex flex-col text-[#454554]">
        <Header />
        <div className="w-full h-full">
            <Outlet />
        </div>
    </div>
);

export default Me;
